import { render, staticRenderFns } from "./Dashboard.orig.vue?vue&type=template&id=22072f14"
import script from "./Dashboard.orig.vue?vue&type=script&lang=js"
export * from "./Dashboard.orig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports